// Fatia S5b: início do backoffice com números gerais e auditoria recente.
import { num } from '@impulso/shared'
import { ErrorState, Loading, PageHead } from '../../ui'
import { AdminNav, AuditTable } from '../../features/admin/AdminNav'
import { useAdminAudit, useAdminStats, usd } from '../../features/admin/api'

const STATUS: Record<string, string> = { trial: 'Em teste', active: 'Ativas', past_due: 'Pagamento atrasado', readonly: 'Somente leitura', suspended: 'Suspensas', canceled: 'Canceladas' }
const CONN: Record<string, string> = { active: 'Ativas', needs_reconnect: 'Precisam reconectar', error: 'Com erro', disconnected: 'Desconectadas' }

export default function AdminHome() {
  const s = useAdminStats()
  const audit = useAdminAudit(undefined, 20)
  return (
    <>
      <PageHead title="Backoffice" sub="Visão geral da plataforma. Tudo o que você faz aqui fica registrado." />
      <AdminNav />
      {s.isLoading && <div className="card"><Loading lines={4} /></div>}
      {s.error && <ErrorState error={s.error} onRetry={() => s.refetch()} />}
      {s.data && (
        <div className="stack">
          <div className="grid g-4">
            <Kpi label="Contas" value={num(Object.values(s.data.accountsByStatus).reduce((a, b) => a + b, 0))} hint={`${s.data.accountsByKind.agency ?? 0} agências · ${s.data.accountsByKind.business ?? 0} negócios`} />
            <Kpi label="Empresas ativas" value={num(s.data.companies)} hint={`${num(s.data.users)} usuários`} />
            <Kpi label="Piloto (24 h)" value={num(s.data.autopilot24h.total)} hint={`${s.data.autopilot24h.succeeded} ok · ${s.data.autopilot24h.failed} falharam · ${s.data.autopilot24h.blocked} bloqueadas`} />
            <Kpi label="IA (24 h)" value={usd(s.data.ai24h.costUsd)} hint={`${num(s.data.ai24h.requests)} chamadas · ${s.data.ai24h.errors} erros`} />
          </div>
          <div className="grid g-2">
            <Breakdown title="Contas por situação" data={s.data.accountsByStatus} labels={STATUS} />
            <Breakdown title="Conexões por situação" data={s.data.connectionsByStatus} labels={CONN} warn={['needs_reconnect', 'error']} />
          </div>
          <div className="card flush">
            <div className="card-head" style={{ padding: '16px 16px 0' }}><h3>Auditoria recente</h3></div>
            {audit.isLoading ? <div style={{ padding: 16 }}><Loading /></div> : audit.error ? <ErrorState error={audit.error} /> : <AuditTable items={audit.data?.items ?? []} />}
          </div>
        </div>
      )}
    </>
  )
}

function Kpi({ label, value, hint }: { label: string; value: string; hint: string }) {
  return <div className="card kpi"><div className="label">{label}</div><div className="value">{value}</div><div className="hint">{hint}</div></div>
}

function Breakdown({ title, data, labels, warn = [] }: { title: string; data: Record<string, number>; labels: Record<string, string>; warn?: string[] }) {
  const entries = Object.entries(data).sort((a, b) => b[1] - a[1])
  return (
    <div className="card">
      <h3 style={{ marginBottom: 12 }}>{title}</h3>
      {entries.length === 0 ? <p className="small muted">Nada ainda.</p> : (
        <div className="list">
          {entries.map(([k, v]) => (
            <div key={k} className="list-item between" style={{ alignItems: 'center' }}>
              <span>{labels[k] ?? k}</span>
              <span className={`badge ${warn.includes(k) && v > 0 ? 'amber' : ''}`}>{num(v)}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
